import { Link } from "react-router-dom";
import { FaHome, FaDumbbell } from "react-icons/fa";
import Navbar from "./user/Navbar";
import Footer from "./user/Footer";

export default function Page404() {
    return (
        <>
            <Navbar />
            <section
                className="d-flex align-items-center justify-content-center text-center"
                style={{
                    height: "100vh", width: "100%", background: `linear-gradient( rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),
        url("../images/images.jpg")`, backgroundSize: "cover", backgroundRepeat: "no-repeat"
                }}>
                <div className="container">
                    <div className="mb-4">
                        <FaDumbbell className="text-danger" style={{ fontSize: "90px" }} />
                    </div>
                    <h1 className="fw-bold text-danger" style={{ fontSize: "120px", lineHeight: "1" }}>
                        404
                    </h1>
                    <h2 className="fw-bold mb-3 text-light">
                        Oops! Page Not Found
                    </h2>
                    <p className="text-light mx-auto mb-5" style={{ maxWidth: "650px" }}>
                        The page you're looking for doesn't exist or may have been
                        moved. Don't let this stop your fitness journey—head back to
                        the homepage and continue your transformation.
                    </p>
                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <Link to="/" className="btn btn-danger btn-lg px-4">
                            <FaHome className="me-2" />Back to Home
                        </Link>
                        <Link to="/user/Programs" className="btn btn-outline-light btn-lg px-4">
                            <FaDumbbell className="me-2" />Explore Programs
                        </Link>
                    </div>
                    <div className="mt-5">
                        <small className="text-light">
                            "Every setback is a setup for a stronger comeback." 💪
                        </small>
                    </div>
                </div>
            </section>
        </>
    );
}